import { render } from "./ChatbotMain.vue?vue&type=template&id=0d9b94f2"
import script from "./ChatbotMain.vue?vue&type=script&lang=js"
export * from "./ChatbotMain.vue?vue&type=script&lang=js"

import "./ChatbotMain.vue?vue&type=style&index=0&id=0d9b94f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__